import './App.css';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { StyleContextProvider } from './providers/StyleContextProvider';
import { AuthContextProvider } from './providers/AuthContextProvider';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { WhatsAppPage } from './pages/WhatsAppPage';
import { AdListPage } from './pages/tuition/AdListPage';
import { NewAdsPage } from './pages/tuition/NewAdPage';
import { AdEditPage } from './pages/tuition/AdEditPage';
import { useEffect } from 'react';
import { PaymentsPage } from './pages/PaymentsPage';
import { OnlineClassWeeksPage } from './pages/online-classes/OnlineClassWeeksPage';
import { StateDegreeListPage } from './pages/degrees/StateDegreeListPage';
import ErrorPage from './pages/ErrorPage';
import { StateDegreeEditPage } from './pages/degrees/StateDegreeEditPage';

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <HomePage /> },
    { path: "admin/:stage?", element: <LoginPage /> },
    { path: "state-degrees", element: <StateDegreeListPage /> },
    { path: "state-degree/edit/:degreeId", element: <StateDegreeEditPage /> },
    { path: "whatsapp-manager", element: <WhatsAppPage /> },
    { path: "tuitions", element: <AdListPage /> },
    { path: "tuitions/new-ads", element: <NewAdsPage /> },
    { path: "tuitions/edit-ads/:adId", element: <AdEditPage /> },
    { path: "payments", element: <PaymentsPage /> },
    { path: "online-classes/weeks", element: <OnlineClassWeeksPage /> },
    { path: "error", element: <ErrorPage/> },
    { path: "*", element: <HomePage /> }
  ]);
  return routes;
};

function App() {

  useEffect(() => {
    if(localStorage.getItem('languageCode') === null) {
      localStorage.setItem('languageCode', "SIN");   
    }    
  });
  
  return (
    <StyleContextProvider>
      <AuthContextProvider>
        <BrowserRouter>          
          <AppRoutes />                   
        </BrowserRouter>
      </AuthContextProvider>      
    </StyleContextProvider> 
  );
}

export default App;
